// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  .info-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${(props) => (props.isShowSuccessMessageState ? `#338b2b` : `#C8102E`)};
    padding: 14px 32px;
    color: white;
    ${(props) =>
      props.fromTrackOrder
        ? 'margin: 0px -28.5px 45px;'
        : 'margin-top: -24px; margin-bottom: 24px;'};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) =>
        props.fromTrackOrder ? 'margin: 0px -8.5px 45px;' : 'margin: 0px -8.5px 20px;'};
      padding: ${(props) => (props.fromTrackOrder ? '14px 28px' : '14px 32px')};
    }
  }
  .outer-cont {
    display: inline-block;
    background-color: white;
    padding: 5px;
    color: #c8102e;
    border-radius: 50%;
    width: 15px;
    height: 15px;
    text-align: center;
    margin-right: 8px;
    font-size: 13px;
    font-weight: 700;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 12px;
      height: 12px;
      font-size: 10px;
    }
  }
  .close-icon {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
  .text-container {
    justify-content: center;
    display: flex;
    align-items: center;
  }
  .check-icon {
    width: 24px;
    height: 24px;
    margin-right: 10px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 20px;
      height: 20px;
    }
  }
`;

export default styles;
